import { api } from "../../gateways/unilabApi";

export async function getColoriSidebar() {
  return await api.get("phe-colors/colori_sidebar");
}
export async function getColoriHeader() {
  return await api.get("phe-colors/colori_header");
}
export async function getColoriBody() {
  return await api.get("phe-colors/colori_body");
}
export async function getColoriCard() {
  return await api.get("phe-colors/colori_card");
}
export async function getColoriFooter() {
  return await api.get("phe-colors/colori_footer");
}
